export default __webpack_public_path__ + "static/media/coin_ltc.153f5bc2.svg";